import ForumApplication from './ForumApplication';
import IndexPage from './components/IndexPage';
import DiscussionPage from './components/DiscussionPage';
import PostsUserPage from './components/PostsUserPage';
import DiscussionsUserPage from './components/DiscussionsUserPage';
import CollectionsUserPage from './dianLiang/CollectionsUserPage';
import SettingsPage from './components/SettingsPage';
import NotificationsPage from './components/NotificationsPage';
import LikesPage from './dianLiang/LikesPage';
import CommentsPage from './dianLiang/CommentsPage';
import PayPage from './dianLiang/PayPage';
import PuzzlePage from './dianLiang/PuzzlePage';
import MallPage from './dianLiang/MallPage';
import MallOrderPage from './dianLiang/MallOrderPage';
import DiscussionPageResolver from './resolvers/DiscussionPageResolver';
import Discussion from '../common/models/Discussion';
import type Post from '../common/models/Post';
import type User from '../common/models/User';
import UserSecurityPage from './components/UserSecurityPage';

/**
 * Helper functions to generate URLs to form pages.
 */
export interface ForumRoutes {
  discussion: (discussion: Discussion, near?: number, sort?: string) => string;
  post: (post: Post) => string;
  user: (user: User) => string;
}

/**
 * The `routes` initializer defines the forum app's routes.
 */
export default function (app: ForumApplication) {
  app.routes = {
    index: { path: '/all', component: IndexPage },

    discussion: { path: '/article/:id', component: DiscussionPage, resolverClass: DiscussionPageResolver },
    'discussion.near': { path: '/article/:id', component: DiscussionPage, resolverClass: DiscussionPageResolver },

    user: { path: '/user/:username', component: DiscussionsUserPage },
    'user.posts': { path: '/user/:username', component: DiscussionsUserPage },
    'user.discussions': { path: '/user/:username/discussions', component: DiscussionsUserPage },
    'user.collections': { path: '/user/:username/collections', component: CollectionsUserPage },

    settings: { path: '/settings', component: SettingsPage },
    'user.security': { path: '/user/:username/security', component: UserSecurityPage },
    notifications: { path: '/notifications', component: NotificationsPage },
    'notifications.likes': { path: '/notifications/:type/likes', component: LikesPage },
    'notifications.comment': { path: '/notifications/:type/comment', component: CommentsPage },
    'pay': { path: '/pay/:type', component: PayPage },
    'puzzle': { path: '/puzzle/:type', component: PuzzlePage },
    'pay.mall': { path: '/pay/:type/mall', component: MallPage },
    'pay.mallorder': { path: '/pay/:type/mallorder', component: MallOrderPage },
  };
}

export function makeRouteHelpers(app: ForumApplication) {
  return {
    /**
     * Generate a URL to a discussion.
     */
    discussion: (discussion: Discussion, near?: number, sort?: string) => {
      
      return app.route('discussion.near', {
        id: discussion.slug(),
        // near: near && near !== 1 ? near : undefined,
        // near: near,
        // sort: sort ? sort : 'top'
      });
    },

    /**
     * Generate a URL to a post.
     */
    post: (post: Post) => {
      return app.route.discussion(post.discussion(), post.number());
    },

    /**
     * Generate a URL to a user.
     */
    user: (user: User) => {
      return app.route('user', {
        username: user.slug(),
      });
    },
  };
}
